import './style.css';
import Library from './lib/Library.js';
import {Map} from './lib/Map.js';
import {BaseLayer} from './lib/BaseLayer.js';
import {MapLayer} from './lib/MapLayer.js';
import {AirepLayer} from './lib/layers/Airep.js';
import {CwaLayer} from './lib/layers/Cwa.js';
import {FltCatLayer} from './lib/layers/FltCat.js';
import {GairmetLayer} from './lib/layers/Gairmet.js';
import {MetarLayer} from './lib/layers/Metar.js';
import {RadarLayer} from './lib/layers/Radar.js';
import {SatelliteLayer} from './lib/layers/Satellite.js';
import {SigmetLayer} from './lib/layers/Sigmet.js';
import {MousePosition} from './lib/controls/MousePosition.js';
import {ScaleLine} from './lib/controls/ScaleLine.js';
import {FullScreen} from './lib/controls/FullScreen.js';
import {DateLabel} from './lib/controls/DateLabel.js';

function init(){
    let map = new Map();
    map.addLayer( new BaseLayer( map, {"type": "globe_light"} ));
    map.addLayer( new SatelliteLayer( map, {"type": "sat_ir" } ));
    map.addLayer( new RadarLayer( map, {"type": "rad_win" } ));
    map.addLayer( new MapLayer( map, {"type": "basic", "visible": true } ));
    map.addLayer( new MapLayer( map, {"type": "county"} ));
    map.addLayer( new MapLayer( map, {"type": "highway"} ));
    map.addLayer( new MapLayer( map, {"type": "jetroute"} ));
    map.addLayer( new MapLayer( map, {"type": "fir"} ));
    map.addLayer( new SigmetLayer( map, {"visible": true} ));
    map.addLayer( new CwaLayer( map ));
    map.addLayer( new GairmetLayer( map ));
    map.addLayer( new MetarLayer( map, {"visible": true} ));
    map.addLayer( new FltCatLayer( map ));
    map.addLayer( new AirepLayer( map, {"visible": true} ));
    map.addControl( new MousePosition( map ));
    map.addControl( new ScaleLine( map ));
    map.addControl( new FullScreen( map ));
    map.addControl( new DateLabel( map ));
    map.setupInput();
    map.setLocation();
    map.setTimeout();

    window.map = map;
}

document.addEventListener("DOMContentLoaded", 
    function() {
        init();
    }
);

